export { default } from "./SubjectIconBrushBorders";
